export enum Theme {
  Dark = 'dark',
  Gold = 'gold',
  Gray = 'gray',
  Light = 'light',
  LightAlt = 'light-alt',
}
